<template>
  <div class="map_legend">
    <div class="legend_item">
      <span class="legend_dot delegate_dot"></span>
      <span>{{ $t("PLACEHOLDERS.delegates") }}</span>
    </div>
    <div class="legend_item">
      <span class="legend_dot distribution_dot"></span>
      <span>{{ $t("PLACEHOLDERS.distribution_points") }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "DelegatesMapLegend",
};
</script>
